import { DocumentNode, useApolloClient } from "@apollo/client";
import { QueryInfo } from "@apollo/client/core/QueryInfo";

function intersect(a: string[], b: string[]) {
  const setB = new Set(b);
  return [...new Set(a)].filter((x) => setB.has(x));
}

export function useGetQueries(toRefetch: string[]) {
  const client = useApolloClient() as any; // any to get access to private props, 😬
  const initialQueries = client.queryManager.queries as Map<string, QueryInfo>;

  const queryDocuments: Record<
    string,
    {
      query: DocumentNode | null;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      variables: Record<string, any> | undefined;
    }
  > = {};
  const allQueries = initialQueries.values();
  for (const queryDoc of allQueries) {
    queryDocuments[queryDoc.queryId] = {
      query: queryDoc.document,
      variables: queryDoc.variables,
    };
  }
  return intersect(
    Object.values(queryDocuments)
      .map((doc) => {
        const def = doc.query?.definitions[0];
        if (def?.kind === "OperationDefinition") {
          return def.name?.value ?? "";
        }
        return "";
      })
      .filter((name) => name !== ""),
    toRefetch,
  );
}
